import { cn } from '../../lib/cn'

/**
 * The club's three insignia (components card §V). They are six lines each and
 * only ever appear together — one file rather than three, so the family reads
 * as a set.
 *
 * Both brass insignia move to brass-DEEP, for the same reason as Eyebrow —
 * these are 9–10.5px caps, which WCAG counts as normal-size text even at 700
 * weight (large text starts at 18.66px bold). As drawn, the outlined badge is
 * 3.38:1 and the solid pill is 3.71:1 parchment-on-brass; both fail AA. Against
 * brass-deep the badge reads 4.6:1 and the pill 5.0:1, and at this size the two
 * brasses are indistinguishable.
 */

/** Solid brass pill — the founding seal, worn on the membership card. */
export function FoundingPill({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-block rounded-club-sm bg-brass-deep px-[9px] py-[3px]',
        'text-[9px] font-bold uppercase tracking-[0.18em] text-parchment',
        className,
      )}
    >
      Founding
    </span>
  )
}

/** Outlined badge naming a member's tier. */
export function TierBadge({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <span
      className={cn(
        'inline-block rounded-club-sm border border-brass px-3 py-[5px]',
        'text-[10.5px] font-bold uppercase tracking-[0.18em] text-brass-deep',
        className,
      )}
    >
      {children}
    </span>
  )
}

/** Sage chip with a leading dot — a member's standing at a glance. */
export function StandingChip({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 rounded-club bg-sage-soft px-[14px] py-1.5',
        'text-xs font-semibold text-fairway',
        className,
      )}
    >
      <span aria-hidden="true" className="size-1.5 rounded-full bg-fairway" />
      {children}
    </span>
  )
}
